export { htmlIDFromString }

function htmlIDFromString(string) {
    return string.toLowerCase().trim().split(' ').join('-')
}